import { calculateOfficeUsageSubformFullCostResults } from "./fullCost";
import {
  EuerDeclarationOfficeUsageSubformUpTo1250EurInputs,
  EuerDeclarationOfficeUsageSubformCalculationResults,
} from "./types";

const MAX_HOME_OFFICE_EXPENSES = 1250_00;

export const calculateOfficeUsageSubformUpTo1250EurResults = (
  inputs: EuerDeclarationOfficeUsageSubformUpTo1250EurInputs
): EuerDeclarationOfficeUsageSubformCalculationResults => {
  const { homeOfficeExpenses: homeOfficeExpensesWithoutCap, paidInputTax = 0 } =
    calculateOfficeUsageSubformFullCostResults(inputs);

  const homeOfficeExpenses = Math.min(
    homeOfficeExpensesWithoutCap,
    MAX_HOME_OFFICE_EXPENSES
  );

  return {
    homeOfficeExpenses,
    paidInputTax,
    profitReduction: homeOfficeExpenses + paidInputTax,
  };
};
